import {
  Button,
  Form,
  Input,
  DatePicker,
  Modal,
  Avatar,
  Card,
  Tag,
  Row,
  Col,
} from "antd";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { authenticateToken } from "../../utils/auth";
import { responseNotification } from "../../utils/notify";
import moment from "moment";
import GiftProductList from "./products";
import { CloseOutlined, GiftOutlined } from "@ant-design/icons";
const { RangePicker } = DatePicker;

const AddGiftVoucher = ({ visibleData, onCloseMethod }: any) => {
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [form] = Form.useForm();
  const [visible, setVisible] = useState(undefined);
  const [status, setStatus] = useState("");
  const [type, setType] = useState("JC_MART");
  const [loading, setLoading] = useState(false);
  const [giftData, setGiftData] = useState(undefined);
  const [error, setError] = useState("");

  const reseAllFieldData = () => {
    setStatus("");
    setType("");
    form.resetFields();
  };

  const onSubmit = async (data) => {
    setLoading(true);

    const readyData = data && {
      active: true,
      fromAmount: data.fromAmount,
      toAmount: data.toAmount,
      products: selectedProducts?.map((product) => ({
        productId: product?.id,
        // quantity: product?.quantity || 1,
        variationId:
          product?.variations?.[0]?.variationId ||
          product?.variation?.variationId,
      })),
    };

    if (giftData) {
      await fetch(`${process.env.REACT_APP_ORDER_API}/admin/gift`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...readyData,
          id: giftData?.id,
          // deleted: false,
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          setLoading(false);

          if (res.statusCode === 200) {
            responseNotification("Gift Updated Successfully", "success");
            form.resetFields();
            if (onCloseMethod) {
              onCloseMethod();
            }
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          setLoading(false);
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    } else {
      await fetch(`${process.env.REACT_APP_ORDER_API}/admin/gift`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(readyData),
      })
        .then((res) => res.json())
        .then((res) => {
          setLoading(false);

          if (res.statusCode === 200) {
            responseNotification("Gift Create Successfully", "success");
            form.resetFields();
            if (onCloseMethod) {
              onCloseMethod();
            }
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          setLoading(false);
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    }
  };

  useEffect(() => {
    if (visibleData) {
      setGiftData(visibleData);
    }
  }, [visibleData]);

  useEffect(() => {
    if (giftData) {
      form.resetFields(Object.keys(visibleData));
    }
  }, [giftData]);

  return (
    <div className="">
      <div className="drawer-toggle-inner-wrapper">
        <Form
          name="control-hooks"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          onFinish={onSubmit}
          form={form} // like ref
          layout="vertical"
          initialValues={{
            ...giftData,
            startFrom: moment(giftData?.startFrom),
            endAt: moment(giftData?.endAt),
          }}
        >
          <Form.Item
            hasFeedback
            label="From Amount"
            rules={[
              {
                required: true,
                message: "From Amount is Required!",
              },
              {
                validator: async (_, value) => {
                  if (value && !(parseFloat(value) > 0)) {
                    return Promise.reject(new Error("Invalid Amount"));
                  }
                },
              },
            ]}
            name="fromAmount"
            style={{ minWidth: "100%" }}
          >
            <Input
              id="fromAmount"
              type="text"
              placeholder="Enter From Amount"
            />
          </Form.Item>

          <Form.Item
            hasFeedback
            label="To Amount"
            // rules={[
            //   {
            //     required: true,
            //     message: "To Amount is Required!",
            //   },
            //   {
            //     validator: async (_, name) => {
            //       if (name && !(parseFloat(name) > 0)) {
            //         return Promise.reject(new Error("Invalid Amount"));
            //       }
            //     },
            //   },
            // ]}
            rules={[
              { required: true },
              {
                validator: async (_, value) => {
                  if (value && !(parseFloat(value) > 0)) {
                    return Promise.reject(new Error("Invalid Amount"));
                  }
                  if (value > 0) {
                    return Promise.reject(
                      new Error("Amount Must be Greter than To Amount")
                    );
                  }
                },
              },
            ]}
            name="toAmount"
            style={{ minWidth: "100%" }}
          >
            <Input id="toAmount" type="text" placeholder="Enter To Amount" />
          </Form.Item>

          {/* <Form.Item name="range">
            <RangePicker
              onChange={(e, f) => {
                console.log("momnet", moment(f[0])?.toISOString());
                setDateRange({ from: f?.[0], to: f?.[1] });
              }}
              showTime={{
                hideDisabledOptions: true,
                defaultValue: [
                  moment("00:00:00", "HH:mm:ss"),
                  moment("23:59:59", "HH:mm:ss"),
                ],
              }}
              inputReadOnly
              allowClear
            />
          </Form.Item> */}
          <Button
            danger
            block
            type="dashed"
            size="large"
            onClick={() => setVisible(true)}
          >
            <GiftOutlined /> Add Gift Item
          </Button>

          {/* {selectedProducts && ( */}
          <Row gutter={10}>
            {selectedProducts?.map((product, index) => (
              <Col span={12}>
                <Card
                  size="small"
                  className="mt-2"
                  title={product?.name}
                  key={index}
                  extra={
                    <Button
                      type="text"
                      onClick={async () => {
                        await setSelectedProducts((prevProducts: any) => {
                          const arr = Array.from(prevProducts);
                          const newArr = arr.filter(
                            (item: any) => item?.id !== product?.id
                          );
                          return newArr;
                        });
                      }}
                    >
                      <CloseOutlined />
                    </Button>
                  }
                >
                  <Avatar size={150} src={product?.productImage} />
                </Card>
              </Col>
            ))}
          </Row>
          {/* )} */}

          <div className="buttons-container mt-4">
            <Button
              disabled={loading || !!error}
              loading={(loading ? "loading" : undefined) as any}
              type="primary"
              htmlType="submit"
              className="add-submit-btn text-center mr-2"
            >
              Submit
            </Button>
            <Button
              type="ghost"
              htmlType="button"
              onClick={() => {
                // form?.resetFields();
                reseAllFieldData();
              }}
              className="reset-submit-btn text-center mr-2"
            >
              Reset
            </Button>
          </div>
        </Form>
      </div>
      <Modal
        title={`Add Product for Gift`}
        centered
        visible={visible}
        onOk={() => {
          setVisible(undefined);
          // editOrderProducts();
        }}
        destroyOnClose
        onCancel={() => {
          setVisible(undefined);
        }}
        width={"80%"}
        className="orderProductModal"
      >
        <GiftProductList
          selectedProducts={selectedProducts}
          setSelectedProducts={async (products) => {
            setSelectedProducts(products);
          }}
        />
      </Modal>
    </div>
  );
};

export default AddGiftVoucher;
